angular.module('mercury.modules.budget', [
  'mercury.modules.budget.worksheet'
]);
